var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-abuse-banner",class:{
    'report-abuse-banner--top': _vm.top,
  }},[_c('div',[_c('span',{staticClass:"bold mr-3"},[_vm._v("Got Scammed?")]),_c('span',{staticClass:"bold-700 warning-text-red pointer",on:{"click":function($event){return _vm.$router.push({ name: 'report-abuse' })}}},[_vm._v("Report Abuse")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }